import Stack from '@mui/material/Stack';
import type { GetBidderCreativeQuery } from '../../../graphql/query/creatives/GetBidderCreative.generated';
import type { AdvertiserOption, ContentCategoryOption } from '../types';
import { CreativeContentDetailsSection } from './sections/CreativeContentDetailsSection';
import { CreativeContentSection } from './sections/CreativeContentSection';
import { CreativeDetailsSection } from './sections/CreativeDetailsSection';

type CreativeDetailsTabProps = {
  creative: NonNullable<GetBidderCreativeQuery['bidderCreativeById']>;
  advertiserOptions: AdvertiserOption[];
  iabCategoryOptions: ContentCategoryOption[];
};

export const CreativeDetailsTab = ({ creative, advertiserOptions, iabCategoryOptions }: CreativeDetailsTabProps) => {
  return (
    <Stack direction="column">
      <CreativeDetailsSection creative={creative} advertiserOptions={advertiserOptions} />
      <CreativeContentSection creative={creative} />
      <CreativeContentDetailsSection creative={creative} iabCategoryOptions={iabCategoryOptions} />
    </Stack>
  );
};
